<template>
  <div class="component__receipt-form">
    <hr />
    <b-row class="cart__items-label font-weight-bold mx-0 w-100">
      <b-col ref="text__form-title" class="pl-0 mb-1 text__payment-title">
        Receipt Information</b-col
      >
    </b-row>
    <b-form ref="reciptForm" class="recipt-form p-0 m-0" @submit="submit">
      <!-- Name -->
      <label ref="label__name" for="input__name" class="mb-u2 mt-u4">Name</label>
      <b-form-input
        ref="input__name"
        v-model="form.name"
        for="input__name"
        class="input__name"
        :class="{
          'is-invalid': $v.form.name.$error
        }"
      >
      </b-form-input>
      <b-form-invalid-feedback
        v-if="!$v.form.name.required"
        ref="input__error-required"
        class="mt-2"
      >
        Name is required
      </b-form-invalid-feedback>

      <!-- Address -->
      <label ref="label__address" for="input__address" class="mb-2 mt-u6">
        Receipt Address
      </label>
      <b-form-textarea
        ref="input__address"
        v-model="form.address"
        for="input__address"
        class="input__address"
        rows="3"
        :placeholder="address_placeholder"
        :class="{
          'is-invalid': $v.form.address.$error
        }"
      >
      </b-form-textarea>
      <b-form-invalid-feedback
        v-if="!$v.form.address.required"
        ref="input__error-address-required"
        class="mt-2"
      >
        Receipt Address is required
      </b-form-invalid-feedback>
    </b-form>
    <b-col class="text__list-description mt-u6">
      <ul class="mb-0">
        <li>
          Your name and receipt address cannot be changed after making a payment. Please ensure all
          information is correct.
        </li>
        <li>The receipt will appear in My Purchase within 5-7 business days.</li>
      </ul>
    </b-col>
  </div>
</template>

<script>
import { userInfoMixin } from '@/mixins/userInfoMixin';
import { required } from 'vuelidate/lib/validators';

export default {
  mixins: [userInfoMixin],

  data() {
    return {
      address_placeholder:
        'e.g, มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรี. 126 ถนนประชาอุทิศ แขวงบางมด เขตทุ่งครุ กรุงเทพฯ 10140',
      form: {
        name: '',
        address: ''
      }
    };
  },
  validations() {
    return {
      form: {
        name: {
          required
        },
        address: {
          required
        }
      }
    };
  },
  computed: {},
  created() {
    this.init();
  },
  methods: {
    init() {
      this.updateUserData();
    },

    isThaiText(text) {
      // Thai Unicode range: \u0E00-\u0E7F
      return /[\u0E00-\u0E7F]/.test(text);
    },

    updateUserData() {
      const { firstname, lastname } = this.user;
      const prefix = this.isThaiText(firstname) ? 'คุณ' : 'คุณ ';
      this.$set(this.form, 'name', `${prefix}${firstname} ${lastname}`);
    },
    submit() {
      this.$emit('submit:receipt-form', this.form);
    }
  }
};
</script>

<style lang="scss" scoped>
.text__list-description {
  background-color: #eceef7;
  border-radius: 10.4px;
  padding: 12px 20px;
}

.component__receipt-form {
  textarea {
    font-size: 15.2px;
  }
}
</style>
